
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Shirditomumbaicab() {



    const cardData =
    {
        keyword: 'Shirdi to Mumbai Cab',
        heading: 'S9 Travels: Shirdi to Mumbai Cab',
        headingDescription: 'S9 Travels offers reliable and comfortable Shirdi to Mumbai cab services, ensuring a smooth and stress-free journey. The distance from Shirdi to Mumbai is approximately 240 km, with a travel time of around 5 to 6 hours by road. Our well-maintained cabs, professional drivers, and top-notch customer service guarantee a safe and enjoyable ride. Whether you are traveling for business, leisure, or a return from a spiritual visit, S9 Travels provides a seamless and hassle-free travel experience.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "The Gateway of India is an iconic monument built in 1924 to commemorate the visit of King George V and Queen Mary to Mumbai. Overlooking the Arabian Sea, it is a popular tourist attraction and a symbol of the city's colonial history."
    },
    {
      "title": "Marine Drive",
      "description": "Marine Drive, also known as the 'Queen’s Necklace,' is a 3.6 km-long boulevard along the coastline of South Mumbai. It offers stunning views of the Arabian Sea and is a favorite spot for evening walks and sunsets."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus",
      "description": "A UNESCO World Heritage Site, this historic railway station is an architectural marvel showcasing Victorian Gothic Revival style. It is one of Mumbai’s busiest railway stations and a landmark of the city’s colonial past."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these ancient rock-cut caves house stunning sculptures and carvings dedicated to Lord Shiva. A UNESCO World Heritage Site, it is accessible via a ferry ride from the Gateway of India."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "Dedicated to Lord Ganesha, Siddhivinayak Temple is one of Mumbai’s most famous temples. Devotees from all over the country visit this temple to seek blessings and experience the spiritual atmosphere."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Haji Ali Dargah is a beautiful mosque and tomb situated on a small islet in the Arabian Sea. It is a significant religious site for both Muslims and people of other faiths, offering a peaceful and spiritual ambiance."
    },
    {
      "title": "Colaba Causeway",
      "description": "A paradise for shoppers, Colaba Causeway is a bustling street market offering a variety of clothes, jewelry, antiques, and souvenirs. It is also home to popular cafes and restaurants like Leopold Café and Café Mondegar."
    },
    {
      "title": "Juhu Beach",
      "description": "Juhu Beach is one of Mumbai’s most famous beaches, known for its lively atmosphere and delicious street food. It is a great place to relax, enjoy the sea breeze, and try local snacks like vada pav and pav bhaji."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "The Bandra-Worli Sea Link is an architectural wonder connecting the western suburbs of Mumbai with South Mumbai. It offers stunning views of the city skyline, especially when illuminated at night."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "A green oasis in the heart of Mumbai, Sanjay Gandhi National Park is home to diverse wildlife, scenic trails, and the ancient Kanheri Caves. It is a perfect getaway for nature lovers and adventure enthusiasts."
    }
],

"services": [
    {
      "name": "Pune to Mumbai Airport Round Trip Innova",
      "description": "For those who need a round-trip taxi to Mumbai Airport, our Innova cabs offer a great option. Book a round trip to ensure you have a reliable vehicle both ways. Our round-trip service includes pick-up from Pune, a safe journey to the airport, and a return trip after your flight."
    },
    {
      "name": "Private Innova Cab from Pune to Mumbai Airport",
      "description": "Book a private Innova cab for your Pune to Mumbai Airport trip. Whether you’re traveling alone, with family, or in a group, having a private vehicle ensures that you can travel in privacy and comfort."
    },
    {
      "name": "Affordable Pune to Mumbai Airport Innova",
      "description": "Travel affordably with an Innova taxi from Pune to Mumbai Airport. We offer competitive prices without compromising on comfort. Whether it’s a solo trip or with family, our affordable Innova taxis ensure great value for money."
    },
    {
      "name": "Group Travel to Mumbai Airport by Innova",
      "description": "Traveling with a group? Our Innova cabs are ideal for group travel to Mumbai Airport. With ample space for luggage and passengers, everyone can travel together in comfort. Book a group travel Innova for a smooth and enjoyable airport trip."
    },
    {
      "name": "Luxury Innova for Mumbai Airport",
      "description": "For those looking for a luxury ride to Mumbai Airport, our luxury Innova cabs offer premium features such as plush seating, air conditioning, and a smooth ride for a top-tier travel experience. Perfect for business travelers or those looking for extra comfort."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Airport Round Trip Innova", "Private Innova Cab from Pune to Mumbai Airport"],
    ["Affordable Pune to Mumbai Airport Innova", "Group Travel to Mumbai Airport by Innova"],
    ["Luxury Innova for Mumbai Airport", "Pune to Mumbai Airport Round Trip Innova"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we ensure that your journey from Shirdi to Mumbai is comfortable and punctual. We offer prompt pickups from your location in Shirdi and guarantee a smooth drive to Mumbai. Our drivers are punctual and dedicated to getting you to your destination on time."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is perfect for your trip from Shirdi to Mumbai. With comfortable seating, air conditioning, and ample space for luggage, you can enjoy a relaxing and stress-free journey. Whether you're traveling alone or with family or friends, you'll have a pleasant ride throughout the journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes from Shirdi to Mumbai. They are courteous, knowledgeable, and focused on ensuring your journey is smooth and safe. With their expertise, you can relax and enjoy the ride."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Shirdi to Mumbai cab ride. You'll receive a clear breakdown of all costs upfront with no hidden charges, so you can plan your travel budget comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring that your journey from Shirdi to Mumbai is both secure and comfortable."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, ensuring that you can travel from Shirdi to Mumbai whenever you need to. Whether it’s early in the morning or late at night, we will make sure your ride is ready. Our customer service team is always available to assist with your booking needs."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Shirdi to Mumbai cab is simple and convenient with S9 Travels. You can book online through our website or mobile app, or contact our customer service team for personalized assistance in reserving your cab."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "If you have specific preferences or need additional services during your trip, we offer customized travel packages for your journey from Shirdi to Mumbai. Whether you want to make stops along the way or have specific requests, we tailor the experience to fit your needs."
  }
]













    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Shirdi to Mumbai with S9 Travels?',
            answer: 'Booking a cab for your Shirdi to Mumbai trip is simple! You can book online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Shirdi to Mumbai travel?',
            answer: 'We offer various cabs, including the spacious Toyota Innova, perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that best fits your needs for a comfortable journey.'
          },
          {
            question: 'Are the drivers experienced for the Shirdi to Mumbai route?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes from Shirdi to Mumbai. They ensure a smooth, safe, and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab from Shirdi to Mumbai?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and secure online payments via our mobile app, providing flexibility and convenience.'
          },
          {
            question: 'Can I book a round trip from Shirdi to Mumbai?',
            answer: 'Yes, we offer round-trip bookings. Simply provide us with your return details, and we’ll arrange a smooth and comfortable ride back from Mumbai to Shirdi.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges, such as for detours or waiting time, will be clearly communicated to you upfront, ensuring transparency in the pricing structure.'
          },
          {
            question: 'Can I make additional stops on the way from Shirdi to Mumbai?',
            answer: 'Yes, you can request additional stops. Please inform us during the booking process, and we’ll accommodate your requests for stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Shirdi to Mumbai trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or special requirements, please let us know when booking, and we will make necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Shirdi to Mumbai?',
            answer: 'Yes, we offer corporate travel services for business trips from Shirdi to Mumbai, ensuring a comfortable, professional, and timely service.'
          },
          {
            question: 'Why should I choose S9 Travels for my Shirdi to Mumbai cab booking?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey from Shirdi to Mumbai.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Harish Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Shirdi to Mumbai with S9 Travels, and the experience was fantastic. The driver was punctual and professional, the vehicle was clean, and the journey was smooth. Highly recommend their services for long-distance travel!”'
        },
        {
          name: 'Mrs. Aarti Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I traveled from Shirdi to Mumbai with my family using S9 Travels, and it was a comfortable and pleasant journey. The driver was courteous, and the car was spacious and well-maintained. I will definitely use S9 Travels again for future trips!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Shirdi to Mumbai Cab",
        "description": "Book a safe, comfortable, and affordable Shirdi to Mumbai cab service with S9 Travels. Whether you’re traveling for business, leisure, or a pilgrimage, our professional drivers will ensure a smooth and hassle-free journey. Choose from one-way or round-trip options with well-maintained vehicles and flexible schedules.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "2105"
        }
      };
    
      
      
      
      


    return (
        <div>
        
        
        <Helmet>
        <title>Shirdi to Mumbai Cab | Safe & Comfortable Taxi Service | S9 Travels</title>
        <meta 
          name="description" 
          content="Book your Shirdi to Mumbai cab with S9 Travels for a comfortable, safe, and affordable ride. Choose from one-way or round-trip options with professional drivers and well-maintained vehicles for a smooth and hassle-free journey." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/92.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Shirditomumbaicab;